import { render, staticRenderFns } from "./MonitorParagraphObject.vue?vue&type=template&id=80b3f4d0&"
import script from "./MonitorParagraphObject.vue?vue&type=script&lang=js&"
export * from "./MonitorParagraphObject.vue?vue&type=script&lang=js&"
import style0 from "./MonitorParagraphObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports